import { Button } from '@parrot-software/design-system';
import { cn } from '@parrot-software/utils';

interface RecommendButtonProps {
  className?: string;
  href: string;
  label: string;
}

/**
 * Red pill call-to-action that opens the referral WhatsApp conversation in a new tab.
 * Shared by the hero and the closing banner.
 *
 * Uses the design-system Button (primary variant) rendered as an anchor via `asChild`.
 *
 * @param {RecommendButtonProps} props - Component properties
 * @returns {React.ReactElement} The CTA link
 */
export const RecommendButton = ({ className, href, label }: RecommendButtonProps) => (
  <Button asChild className={cn('h-auto rounded-full px-7 py-3.5 text-base', className)} size="lg">
    <a href={href} rel="noopener noreferrer" target="_blank">
      {label}
    </a>
  </Button>
);
